export default "__VITE_ASSET__CDSytgd3__"